import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navItems = [
  { path: "/", label: "首页", icon: "ri-home-4-line" },
  { path: "/category/dianying", label: "电影", icon: "ri-movie-2-line" },
  { path: "/category/dianshiju", label: "电视剧", icon: "ri-tv-2-line" },
  { path: "/category/zongyi", label: "综艺", icon: "ri-live-line" },
  { path: "/category/dongman", label: "动漫", icon: "ri-ancient-gate-line" },
  { path: "/about", label: "关于我们", icon: "ri-information-line" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link
          to="/"
          className="flex items-center gap-2 group whitespace-nowrap"
        >
          <div className="w-9 h-9 flex items-center justify-center bg-accent-500 rounded-lg">
            <i className="ri-movie-2-fill text-background-50 text-lg"></i>
          </div>
          <span className="text-xl font-bold text-foreground-950 font-heading">
            屁屁影院
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {navItems.map((item) => {
            const isActive =
              item.path === "/"
                ? location.pathname === "/"
                : location.pathname.startsWith(item.path);
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`relative px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  isActive
                    ? "text-primary-600 bg-primary-50"
                    : "text-foreground-700 hover:text-foreground-950 hover:bg-background-100"
                }`}
              >
                <i className={`${item.icon} mr-1.5`}></i>
                {item.label}
                {isActive && (
                  <span className="absolute bottom-1 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full bg-primary-500"></span>
                )}
              </Link>
            );
          })}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <button className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-100 text-foreground-600 hover:text-foreground-950 hover:bg-background-200 transition-colors cursor-pointer whitespace-nowrap">
            <i className="ri-search-line text-lg"></i>
          </button>
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg bg-background-100 text-foreground-700 cursor-pointer whitespace-nowrap"
        >
          <i
            className={`text-lg ${mobileOpen ? "ri-close-line" : "ri-menu-3-line"}`}
          ></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 shadow-lg">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navItems.map((item) => {
              const isActive =
                item.path === "/"
                  ? location.pathname === "/"
                  : location.pathname.startsWith(item.path);
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-colors cursor-pointer ${
                    isActive
                      ? "text-primary-600 bg-primary-50"
                      : "text-foreground-700 hover:bg-background-100"
                  }`}
                >
                  <i className={`${item.icon} text-lg`}></i>
                  {item.label}
                </Link>
              );
            })}
          </div>
        </div>
      )}
    </nav>
  );
}